import { getReportParams, report } from '../../../middleware/report';

export function dwhMarketingPageEntry(subscriber) {
  let reportParams = getReportParams();
  reportParams.area = 'Support';
  reportParams.subArea = 'Cellular';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'MarketingPageEntry';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Marketing Page Displayed';
  reportParams.param1 = subscriber;

  report(reportParams);
}

export function dwhSerialNumberInput() {
  let reportParams = getReportParams();
  reportParams.area = 'Support';
  reportParams.subArea = 'Cellular';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'SerialNumberInput';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Serial Number Entered';

  report(reportParams);
}

export function dwhCheckButtonClick() {
  let reportParams = getReportParams();
  reportParams.area = 'Support';
  reportParams.subArea = 'Cellular';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'CheckButtonClick';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Block Check Performed';

  report(reportParams);
}

export function dwhCheckSuccess() {
  let reportParams = getReportParams();
  reportParams.area = 'Support';
  reportParams.subArea = 'Cellular';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'CheckSuccess';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Check Succeeded';

  report(reportParams);
}

export function dwhCheckFailure() {
  let reportParams = getReportParams();
  reportParams.area = 'Support';
  reportParams.subArea = 'Cellular';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'CheckFailure';
  reportParams.status = 'Error';
  reportParams.messageText = 'CheckFailed';

  report(reportParams);
}


